import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaypointResponse } from '../../../models/paypoint-response.interface';

@Component({
  selector: 'kt-bridgepay-view-paypoints',
  templateUrl: './view-paypoints.component.html',
  styleUrls: ['./view-paypoints.component.scss'],
})
export class ViewPaypointsComponent {
  @Input() paypoints: PaypointResponse[] = [];
  @Output() addPaypoint = new EventEmitter<void>();
  @Output() editPaypoint = new EventEmitter<PaypointResponse>();
  @Output() testPaypoint = new EventEmitter<PaypointResponse>();
  @Output() deletePaypoint = new EventEmitter<PaypointResponse>();

  onAddPaypoint(): void {
    this.addPaypoint.emit();
  }

  onEdit(paypoint: PaypointResponse): void {
    this.editPaypoint.emit(paypoint);
  }

  onTest(paypoint: PaypointResponse): void {
    this.testPaypoint.emit(paypoint);
  }

  onDelete(paypoint: PaypointResponse): void {
    this.deletePaypoint.emit(paypoint);
  }
}
